import React, {useEffect, useState} from "react";
import S360WidgetBlock from "root/s360components/LearningJournal/S360WidgetBlock";
import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import S360WidgetContainer from "root/s360components/LearningJournal/S360WidgetContainer";
import HookSubFormRegistrationFilters, {
    regFilters, RegistrationFilterNames
} from "root/s360components/Registration/HookSubFormRegistrationFilters";
import {useForm} from "react-hook-form";
import HookSubFormRegistrationTable, {
    childRegFields, ChildRegistrationDetails
} from "root/s360components/Registration/HookSubFormRegistrationTable";
import {getClassForRegistration, registerClass} from "root/DataFunctions/RegistrationDataFns";
import {getDataFromResponse} from "root/globals";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import format from "date-fns/format";
import useModalRegistrationResponse from "root/s360components/Modals/Registration/useModalRegistrationResponse";
import './RegistrationPage.scss';
import {AM_OBJ, PM_OBJ} from "root/s360components/ReactHookForm/ui/DropdownAMPM";
import {extractAbsenceCodeFromLabel, LATE_CODES} from "root/s360components/Registration/RegistrationTableItem";
import useModalRegistrationValidation, {ModalRegistrationValidationModes} from "root/s360components/Modals/Registration/useModalRegistrationValidation";
import RegistrationTitle from "root/s360components/Registration/RegistrationTitle";

import ErrorBoundaryS360 from "root/s360components/ReactErrorBoundaryS360/ErrorBoundaryS360";

export const RegistrationFormSections = {
    FILTERS: 'filters',
    REGISTRATION: 'registration'
}

const EMPTY_DATA = {
    isLoading: true,
    data: [],
}

const MIS_TYPE = {
    WONDE: 1,
    ARBOR: 2,
    UNKNOWN: 99
}

const EMPTY_FILTER_ERR = {error: false, msg: ""};

const EMPTY_REG_ERR = {error: false, msg: ""};

const EMPTY_PHRASE = {title: null, buttonText: null, textColor: null};

const CLASSVIEW_LINK = '/eyfs_admin.php?page=classes_n&menu=4';

const RegistrationPage = ({school_id, class_id_filter}) =>
{
    const isArbor = true;

    const queryParameters = new URLSearchParams(window.location.search);
    const session_filter = queryParameters.get("session"); //only get the session here as class_id is passed via php_vars

    const [data, setData] = useState(EMPTY_DATA);
    const [isFetching, setIsFetching] = useState(false);
    const [showFilterError, setShowFilterError] = useState(EMPTY_FILTER_ERR);

    const [submissionPhrase, setSubmissionPhrase] = useState(EMPTY_PHRASE);

    const [renderSuccessModal, activateSuccessModal] = useModalRegistrationResponse();

    const [renderValidationModal, activateValidationModal] = useModalRegistrationValidation();

    const getRegistrationData = (school_id, class_id, date, session) =>
    {
        if (class_id === 0 || session === "No sessions") //Default values for class_id and session as set in regFilters() in the subform
        {
            setShowFilterError({error: true, msg: "You need to set all filters before you can fetch registration data."})
        }
        else
        {
            setShowFilterError(EMPTY_FILTER_ERR);
            setData(EMPTY_DATA);
            setIsFetching(true);

            getClassForRegistration(school_id, class_id, date, session, (response) =>
            {
                const pupilRows = getDataFromResponse(response)[0];

                const values = getValues(RegistrationFormSections.FILTERS);

                const defVals = {
                    [RegistrationFormSections.FILTERS]: values,
                    ...childRegFields(pupilRows)
                }

                reset(defVals);

                const title = pupilRows.registered === true ? "Update Registration" : "New Registration";
                const buttonText = pupilRows.registered === true ? "Update Register" : "Submit Register";
                const color = pupilRows.registered === true ? "#ad4f4f" : "#267708";

                setSubmissionPhrase({title: title, buttonText: buttonText, textColor: color});

                setData({isLoading: false, data: pupilRows})
            });
        }
    }

    const getInititalSessionObject = (session) =>
    {
        if (session === 'PM')
        {
            return PM_OBJ;
        }
        else if (session === "AM")
        {
            return AM_OBJ;
        }
        else
        {
            return null;
        }
    }


    const {register, control, trigger, handleSubmit, setFocus, watch, setValue, getValues, reset, resetField, formState: {errors: formErrors, isDirty, dirtyFields}} = useForm(
        {
            defaultValues: {
                ...regFilters(getInititalSessionObject(session_filter)),
            }
        });



    const controlProps = {
        control: control,
        register: register,
        watch: watch,
        reset: reset,
        resetField: resetField,
        formErrors: formErrors,
        setValue: setValue,
        getValues: getValues,
        trigger: trigger
    }

    useEffect(() =>
    {
        if (session_filter !== "null" && class_id_filter !== "null" && session_filter !== null && class_id_filter !== null)
        {
            getRegistrationData(school_id, +class_id_filter, format(new Date(), "yyyy-MM-dd"), session_filter )
        }
    },[])


    const watchSession = watch(RegistrationFormSections.FILTERS + '.' + RegistrationFilterNames.SESSION); //e.g. "filters.session"
    const watchDate = watch(RegistrationFormSections.FILTERS + '.' + RegistrationFilterNames.DATE);
    const watchClasses = watch(RegistrationFormSections.FILTERS + '.' + RegistrationFilterNames.CLASSES);
    const watchLunch = watch(RegistrationFormSections.FILTERS + '.' + RegistrationFilterNames.LUNCH);

    const onClickGetClass = () =>
    {
        const formattedDate = format(watchDate, "yyyy-MM-dd");

        getRegistrationData(school_id, watchClasses.value, formattedDate, watchSession.label);
    }

    const checkAbsenceCodeStatusMatch = (regData) =>
    {
        let badItems = [];

        Object.keys(regData).forEach(key => {
            const value = regData[key];

            if (value.absence_code.value === "0" && value.absence_status.value !== "")
            {
                badItems.push(key);
            }
        })

        return badItems;
    }

    const validateEnforcedCommentCode = (regData) =>
    {

        let errors = {error: false, code: "N/A"};

        //Loop through all items in reg data
        Object.keys(regData).forEach(key => {
            const value = regData[key];

            const requires_comment = value.absence_code.requires_comment;

            if (requires_comment === 1)
            {
                //check if comment has been set
                if (value.absence_comment === "")
                {
                    errors = {error: true, code: value.absence_code.label};
                }
            }
        })

        return errors;
    }

    const checkVoidAbsenceCode = (regData) =>
    {
        let badItems = [];

        Object.keys(regData).forEach(key => {
            const value = regData[key];

            if (value.absence_code === null || value.absence_code === undefined)
            {
                badItems.push(key);
            }
        })

        return badItems;
    }

    const checkMinutesLate = (regData) =>
    {
        let badItems = [];

        Object.keys(regData).forEach(key => {
            const value = regData[key];

            const absence_code = extractAbsenceCodeFromLabel(value.absence_code.label);

            if (LATE_CODES.includes(absence_code) === false)
            {
                if (value.minutes_late !== '')
                {
                    badItems.push({item: key, reason: "A pupil in this registration has been assigned a number of minutes late without a matching 'L - Late' or 'U - Late' absence code - Please amend this before resubmission."});
                }
            }
            else
            {
                if (value.minutes_late === '')
                {
                    badItems.push({item: key, reason: "A pupil in this registration has been assigned an 'L - Late' or a 'U - Late' absence code without a number of minutes - Please amend this before resubmission."});
                }
            }
        })

        return badItems;
    }

    const errorAndFocus = (message, focusName) =>
    {
        //Validation rules were broken (Absent status but no absence code set)
        activateValidationModal({mode: ModalRegistrationValidationModes.VIEW, message: message})
            .then(() =>
            {
                //setFocus(focusName, { shouldSelect: true }); // THIS DOESN'T WORK - Kept for future reference if it ever wants to be fixed
            })
    }

    const onSubmit = (formData) =>
    {
        const checkVoidAbsenceCodes = checkVoidAbsenceCode(formData.registration);


        if (checkVoidAbsenceCodes.length === 0)
        {
            //This entire submit is written horribly but only required a quick fix
            const checkCodeStatusUserIds = checkAbsenceCodeStatusMatch(formData.registration);

            const validateEnforcedCommentCodes = validateEnforcedCommentCode(formData.registration);

            const checkMinutesLateWithCode = checkMinutesLate(formData.registration);

            if (checkCodeStatusUserIds.length !== 0)
            {
                errorAndFocus("A pupil was set to absent but no absence code was added to the record - Please amend this before resubmission.",
                    RegistrationFormSections.REGISTRATION + '.' + checkCodeStatusUserIds[0] + '.' + ChildRegistrationDetails.ABSENCE_CODE);
            }
            else if (validateEnforcedCommentCodes.error)
            {
                const errMessageDetail = extractAbsenceCodeFromLabel(validateEnforcedCommentCodes.code) === "B" ? "nature of activity" : "details";

                errorAndFocus("Absence code: '" + validateEnforcedCommentCodes.code + "' requires schools MUST record " + errMessageDetail + " in the comment section - Please amend and resubmit.",
                    RegistrationFormSections.REGISTRATION + '.' + checkCodeStatusUserIds[0] + '.' + ChildRegistrationDetails.ABSENCE_COMMENTS
                );
            }
            else if (data.data.mis_type === MIS_TYPE.ARBOR && checkMinutesLateWithCode.length !== 0)
            {
                errorAndFocus(checkMinutesLateWithCode[0].reason,
                    RegistrationFormSections.REGISTRATION + '.' + checkCodeStatusUserIds[0] + '.' + ChildRegistrationDetails.ABSENCE_CODE);
            }
            else
            {
                const formattedDate = format(formData.filters.date, "yyyy-MM-dd");

                registerClass(school_id, formData.filters.classes.value, formattedDate, formData.filters.ampm.label, formData.filters.lunchtoggle, formData.registration, data.data.pupils, (resp) =>
                {

                    let showEmptyResponse = false;
                    if (resp.results.record_set !== null && resp.results.record_set !== undefined)
                    {
                        //Purposeful empty response from the server as there was no difference in the form when it was submitted compared to when the data was populated (the form hadn't changed)
                        showEmptyResponse = true;
                    }
                    else
                    {
                        //something changed in the data
                        showEmptyResponse = false;
                    }

                    activateSuccessModal(formData.filters.classes.label, formData.filters.ampm.label, showEmptyResponse)

                    setData(EMPTY_DATA);
                    setIsFetching(false);
                    setSubmissionPhrase(EMPTY_PHRASE);
                })

            }
        }
        else
        {
            errorAndFocus("An absence code used in this registration is no longer in use and remains empty in this submission. Please amend this code and resubmit.",
                null);
        }
    }

    const submitForm = (formData) =>
    {
        handleSubmit(onSubmit)(formData)
    }

    const cancelForm = () =>
    {
        setData(EMPTY_DATA);
        setIsFetching(false);
        setSubmissionPhrase(EMPTY_PHRASE);
    }

    return (
        <S360WidgetContainer style={{minHeight: '600px', margin: '20px'}}>
            {session_filter !== "null" && <div title=''>
                <a href = {CLASSVIEW_LINK} style={{textDecoration: "none"}}><button style={{margin: "2rem"}}
                        className='btn btn-primary btn-icon glyphicons circle_plus'> Back to Classes</button></a>
            </div>}
            <form onSubmit={(formData) => handleSubmit(onSubmit)(formData, data.data)} className='registration-form'>
            <S360WidgetBlock title=''>
                <RegistrationTitle school_id={school_id} submissionPhrase={submissionPhrase} data={data.data} showMisIcon={isFetching === true && data.isLoading === false}/>
                <BootstrapRow>
                    <BootstrapCol width={12}>
                        <div className='registration-filters-grid'>
                            <HookSubFormRegistrationFilters {...controlProps} readOnly={false}
                                                            sectionName={RegistrationFormSections.FILTERS}
                                                            school_id={school_id}
                                                            class_id_filter={class_id_filter}
                            />
                            <div className='registration-filter-item'>
                                <button type='button' style={{marginLeft: "2rem"}}
                                        className='btn btn-primary btn-icon glyphicons circle_plus'
                                        onClick={onClickGetClass}>Fetch class
                                </button>
                            </div>
                        </div>

                            {showFilterError.error === true &&
                                <div><p style={{textAlign: "center", color: "red"}}>{showFilterError.msg}</p></div>}
                    </BootstrapCol>
                </BootstrapRow>
            </S360WidgetBlock>
            <S360WidgetBlock>
                <BootstrapRow>
                    {isFetching === false && <div><p style ={{textAlign: "center"}}>(Select filters to show a class register)</p></div>}
                    {isFetching === true &&
                    <BootstrapCol width={12} >
                        <button type='button' className='btn btn-primary btn-icon glyphicons circle_plus button-style-row' onClick={() => cancelForm()}>Cancel</button>
                        {submissionPhrase.title !== null && <button type='button' className='btn btn-success btn-icon glyphicons circle_plus'  onClick={(formData) => submitForm(formData, data.data)}>{submissionPhrase.buttonText}</button>}
                        {data.isLoading === false && <HookSubFormRegistrationTable {...controlProps} data={data.data} showLunchDropdown={watchLunch} isArbor={data.data.mis_type === MIS_TYPE.ARBOR}/>}
                        {data.isLoading === true && <SpinnerDiv/>}
                        <button type='button' className='btn btn-primary btn-icon glyphicons circle_plus button-style-row' onClick={() => cancelForm()}>Cancel</button>
                        {submissionPhrase.title !== null && <button type='button' className='btn btn-success btn-icon glyphicons circle_plus'  onClick={(formData) => submitForm(formData, data.data)}>{submissionPhrase.buttonText}</button>}
                    </BootstrapCol>}
                </BootstrapRow>
            </S360WidgetBlock>
            </form>
            {renderSuccessModal()}
            {renderValidationModal()}
        </S360WidgetContainer>
    )
}

export default RegistrationPage ;